import { Grid, Text, useMantineColorScheme } from "@mantine/core";
import Rosette from "./rosette/rosette";
import EnergyTable from "./energyTable";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const EnergyBalance = ({ energyBalance = {} }) => {
  const { colorScheme } = useMantineColorScheme();
  const { t } = useTranslation();

  return (
    <Grid gutter="md"  className="indicator-downloadable" style={{ backgroundColor: colorScheme === "dark" ? "#111111" : "#fff" }}>
      <Grid.Col span={8}>
        <Rosette data={energyBalance} />
      </Grid.Col>
      <Grid.Col span={4} className="mt-3">
        <Text
          fw={700}
          size="xl"
          align="center"
          color={colorScheme === "dark" ? "#d5d7e0" : "black"}
          mb="lg"
        >
          {t("result.energyBalance.header")}
        </Text>
        <div>
        <EnergyTable tableData={energyBalance?.tableData} />
        </div>
      </Grid.Col>
    </Grid>
  );
};

EnergyBalance.propTypes = {
  energyBalance: PropTypes.shape({
    tableData: PropTypes.object,
  }),
};

export default EnergyBalance;
